let cache = {
  providers: [],
};

const setCache = (newCache) => {
  cache = {
    ...cache,
    ...newCache,
  };
};

const getCache = () => cache;

const getCachedProviders = () => getCache().providers || [];

export default {
  setCache,
  getCache,
  getCachedProviders,
  getCachedFillProviders: () => getCache().fillProviders || [],
  getCachedFreightProviders: () => getCache().freightProviders || [],
};
